<template>
    <div class="container" v-if="user.isAdmin">
        <h1 class="mt-2 mb-4 font-sans-bold">
          Your Profile <MasqueradeAsUser :user="user" />
        </h1>
        <form>
            <div class="mb-12">
                <label for="first_name">
                    First name
                </label>
                <input id="first_name" type="text" name="first_name" autocomplete="off"
                    v-validate="'required'"
                    v-model="form.first_name">
                <span v-show="errors.has('first_name')" class="error text-error-red text-lg">{{ errors.first('first_name') }}</span>
            </div>

            <div class="mb-12">
                <label for="last_name">
                    Last name
                </label>
                <input id="last_name" type="text" name="last_name" autocomplete="off"
                    v-validate="'required'"
                    v-model="form.last_name">
                <span v-show="errors.has('last_name')" class="error text-error-red text-lg">{{ errors.first('last_name') }}</span>
            </div>

            <div class="mb-12">
                <label for="email">
                    Email
                </label>
                <input id="email" type="email" name="email" autocomplete="off"
                    v-validate="'required|email'"
                    v-model="form.email">
                <span v-show="errors.has('email')" class="error text-error-red text-lg">{{ errors.first('email') }}</span>
            </div>

            <div class="mb-12">
                <label for="squadupUserId">
                    Squadup User Id
                </label>
                <input id="squadupUserId" type="text" name="squadupUserId" autocomplete="off"
                    v-model="form.squadupUserId">
            </div>

            <div class="mb-12">
                <label for="password">
                    Change Password
                    <div class="text-sm font-sans-book">
                        <span class="font-sans-bold">Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number.</span>
                    </div>
                </label>
                <input id="password" type="password" name="password" autocomplete="off"
                    v-validate="'min:8|upperCase|number|lowerCase'"
                    v-model="form.password">
                <span v-show="errors.has('password')" class="error text-error-red text-lg">{{ errors.first('password') }}</span>
            </div>

            <div class="mb-12">
                <div class="select-box">
                <label class="text-base font-normal" for="make-admin">
                    <input id="make-admin" type="checkbox" v-model="form.shouldBeAdmin">
                    <span class="check inline-block mr-2"></span> Make user a system admin
                </label>
                </div>
            </div>

            <button class="button" @click.stop.prevent="validateUpdate">
                Save
            </button>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import MasqueradeAsUser from "./components/MasqueradeAsUser.vue";

    export default {
        name: "UserAdminEdit",
      components: {MasqueradeAsUser},
      title: "User Edit",
        data() {
            return {
                form: {
                    id: "",
                    first_name: "",
                    last_name: "",
                    email: "",
                    password: "",
                    shouldBeAdmin: false,
                    isAdmin: false
                },
                userId: null
            };
        },
        computed: {
            ...mapGetters({
                user: "user"
            })
        },
        watch: {},
        methods: {
            validateUpdate() {
                this.$validator.validate().then(result => {
                    if (!result) {
                        return;
                    }
                    this.update();
                });
            },
            getUser() {
                let route = this.$laroute.route("api.users.show", {
                    user: this.userId
                });

                axios.get(route).then(response => {
                    let user = response.data.data;

                    this.form.id = user.id;
                    this.form.first_name = user.firstName;
                    this.form.last_name = user.lastName;
                    this.form.email = user.email;
                    this.form.squadupUserId = user.squadupUserId;
                    this.form.shouldBeAdmin = user.isAdmin;
                });
            },
            update() {
                let route = this.$laroute.route("api.users.update", {
                    user: this.userId
                });
                this.form.isAdmin = this.user.isAdmin;

                axios
                    .put(route, this.form)
                    .then(response => {
                        this.$toasted.show("This user has been updated");
                        this.form.password = null;
                    })
                    .catch(error => {
                        console.log(error);
                        console.log("error", error.response);
                    });
            }
        },
        mounted() {
            this.userId = this.$route.params.user;
            this.getUser();
        }
    };
</script>
